// extracted by mini-css-extract-plugin
export default {"alert":"styles_alert__WuF8J","animAlert":"styles_animAlert__VuT56","selection":"styles_selection__prZS5"};